module.exports = __webpack_public_path__ + "static/img/Y1D30.7359340.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Y1D30.png
// module id = /jlI
// module chunks = 2